import { render } from 'react-dom';
import { OverlayPosition, OverlayService } from 'shared/components/overlay';
import { AuthModal } from '../Modal';

export interface showAuthPopupSettings {
	title: string;
	showAdvantages?: boolean;
}

export const showAuthPopup = (settings: showAuthPopupSettings) => {
	const overlayElement = document.createElement('div');
	const showAdvantages: boolean = settings.showAdvantages === undefined ? true : settings.showAdvantages;

	const overlayRef = OverlayService.createOverlay(
		overlayElement,
		{ dropShadow: true, position: OverlayPosition.Fill, allowScroll: true });

	render(
		<AuthModal onClose={() => { overlayRef.destroy() }} title={settings.title} showAdvantages={showAdvantages} />,
		overlayElement);
}